export default function SubmitEmailModel(email: any) {
    return {
        email,
    }
}